module.exports = __webpack_public_path__ + "static/media/mattbags.9fb3dd50.png";